import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorLendingCoinList = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="m12.617 10.221.008.004L18.69 7.17a.8.8 0 0 1 1.16.715v4.444c.777.288 1.322.622 1.876.961l.114.07a.75.75 0 0 1-.782 1.28l-.1-.06c-.386-.237-.721-.443-1.108-.625v.942a.8.8 0 0 1-.44.715l-6.5 3.274a.8.8 0 0 1-.979-.207l-6.56-3.305a.8.8 0 0 1-.44-.714v-.898c-.266.13-.479.276-.734.45-.184.126-.389.267-.652.428a.75.75 0 0 1-.783-1.28c.166-.101.323-.209.483-.32.444-.304.917-.628 1.686-.892v-4.5a.8.8 0 0 1 1.16-.715l6.527 3.288Zm-.867 1.242-5.32-2.68v5.446l5.32 2.68v-5.446Zm1.5 5.572 5.1-2.569V9.021l-5.1 2.57v5.444ZM22.799 18.938a.75.75 0 1 0-.998-1.12c-1.16 1.031-3.528 1.914-6.587 2.268a.75.75 0 1 0 .172 1.49c3.17-.367 5.91-1.3 7.413-2.638ZM1.74 17.879a.75.75 0 0 1 1.058-.062c1.16 1.032 3.529 1.915 6.588 2.269a.75.75 0 1 1-.172 1.49c-3.171-.367-5.91-1.3-7.413-2.638a.75.75 0 0 1-.061-1.06ZM2.8 16.1a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM22.3 17.1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
    />
    <path
      fill="#F7A600"
      d="M12.332 1.978a.359.359 0 0 1 .336 0l6.12 3.205c.288.152.288.596 0 .747l-6.12 3.206a.359.359 0 0 1-.336 0L6.212 5.93c-.288-.151-.288-.595 0-.747l6.12-3.205Zm-3.53 3.579L12.5 7.494l3.698-1.937L12.5 3.619 8.802 5.557ZM12.3 22a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
    />
  </svg>
);
export default SvgTwoColorLendingCoinList;
